import React, { useMemo, useRef, useState } from 'react';
import { Checkbox, Dropdown, List } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';
import SvgIcon from '@home/components/SvgIcon';

export default function TableMultipleSelectFilter({
  options,
  value,
  onChange,
  button,
  allOption = {
    value: '-',
    text: 'All',
  },
  listWidth = 240,
  listHeight = 200,
  needFormatMessage = true,
  ...dropdownProps
}: {
  button: (icon: JSX.Element) => JSX.Element | string;
  value: Array<string>;
  onChange: (value: Array<string>) => void;
  options: Array<{ text: any; value: string }>;
  allOption?: { value: string; text: string };
  listWidth?: number | 'auto';
  listHeight?: number;
  dropdownProps?: typeof Dropdown;
  needFormatMessage?: boolean;
}) {
  const valueRef = useRef<Array<string>>(value);

  return (
    <Dropdown
      appearance="pure"
      clickClose={false}
      button={
        <div className={`table-multiple-select-filter-button dbo-select-button-funnel ${value.length !== options.length ? '--active' : ''}`}   >
          {button(
            <SvgIcon
              type="icon-arrow-down"
              className="dbo-funnel-icon"
            ></SvgIcon>,
            // <span className='dbo-funnel-icon'></span>
          )}
        </div>
      }
      closeOnScroll={false}
      placementOffset={[0, 15]}
      boxClassName="table-multiple-select-filter-box"
      onClose={() => onChange(valueRef.current)}
      {...dropdownProps}
    >
      <CheckboxElement
        options={options}
        defaultValues={value}
        allOption={allOption}
        listWidth={listWidth}
        listHeight={listHeight}
        onChange={(value) => (valueRef.current = value)}
        needFormatMessage={needFormatMessage}
      ></CheckboxElement>
    </Dropdown>
  );
}

function CheckboxElement({
  options,
  defaultValues = [],
  onChange,
  allOption,
  listWidth,
  listHeight,
  needFormatMessage,
}: {
  options: Array<{ text: string; value: string }>;
  defaultValues: Array<string>;
  onChange: (value: Array<string>) => void;
  allOption?: { text: string; value: string };
  listWidth?: number;
  listHeight?: number;
  needFormatMessage: boolean;
}) {
  const { formatMessage } = useIntl();
  const [selectValue, setSelectValue] = useState(defaultValues);
  const isAll = useMemo(() => {
    return selectValue.length === options.length;
  }, [selectValue]);
  const changeValue = (value: Array<string>) => {
    setSelectValue(value);
    onChange(value);
  };

  const click = (value: string) => {
    const values = selectValue.includes(value)
      ? selectValue.filter((item) => item !== value)
      : [...selectValue, value];
    changeValue(values);
  };

  const clickAll = () => {
    changeValue(isAll ? [] : options.map((item) => item.value));
  };
  return (
    <List
      type="option"
      className="check-box-element-wrapper"
      style={{ width: listWidth, maxHeight: listHeight }}
    >
      <List.Item onClick={clickAll}>
        <Checkbox
          indeterminate={!isAll && selectValue.length > 0}
          value={isAll}
          onClick={clickAll}
        >
          {formatMessage({ id: allOption?.text })}
        </Checkbox>
      </List.Item>
      {options.map(({ text, value }) => (
        <List.Item key={value} onClick={() => click(value)}>
          <Checkbox
            onClick={() => click(value)}
            name={value}
            value={selectValue.includes(value)}
          >
            {needFormatMessage ? formatMessage({ id: text }) : text}
          </Checkbox>
        </List.Item>
      ))}
    </List>
  );
}
